<template>
    <div class="column-layout flex" style="border: 1px solid #f4f4f4;">
        <div class="col-6 fl">
            <ul class="list-view oper mt10">
                <li class="list-view-item no-hover" style="border-bottom: 1px solid #ccc" v-for="shopDeviceSvcSubNo in shopDeviceSvcSubNos" :class="!shopDeviceSvcSubNo.imported ? 'device-break' : '' ">
                    <div class="ellipsis" :title="shopDeviceSvcSubNo.title">设备名称：{{shopDeviceSvcSubNo.title}}</div>
                    <div class="ellipsis" :title="shopDeviceSvcSubNo.catName">分类：{{shopDeviceSvcSubNo.catName}}</div>
                    <div class="ellipsis" :title="shopDeviceSvcSubNo.brandName">品牌：{{shopDeviceSvcSubNo.brandName}}</div>
                    <div class="item-oper" style="top: 17px;" @click="doDel(shopDeviceSvcSubNo.id)">移除</div>
                    <i v-if="!shopDeviceSvcSubNo.imported" class="icon iconfont icon-break device-break" title="此设备不能关联合同"></i>
                </li>
            </ul>
        </div>
        <div class="col-18 fl pt10 pb10 pl10 pr10" style="border-left: 1px solid #f4f4f4; ">
            <swb-query-sort-area class="mb10" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
            <div class="table-layout">
                <el-table ref="multipleTable" :data="contractGoodsList" border tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
                    <el-table-column width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : selectContractGoods!= null && selectContractGoods.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="contractTitle" label="合同标题" align="left"></el-table-column>
                    <el-table-column prop="contractNo" label="合同编号" width="170" align="center"></el-table-column>
                    <el-table-column prop="contractTypeName" label="合同类型" width="100" align="center"></el-table-column>
                    <el-table-column prop="sndPartyName" label="卖家名称" width="170" align="center"></el-table-column>
                    <el-table-column prop="name" label="商品名称" width="180" align="left"></el-table-column>
                    <el-table-column prop="catName" label="分类名称" width="100" align="left"></el-table-column>
                    <el-table-column prop="brandName" label="品牌名称" width="120" align="left"></el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                               layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import appConf from '../../app.conf';
    import {getDefaultPageSizes} from '../../../src/app.conf'

    import contractApi from '../../api/contract'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "valueType": "String",
                "label": "合同标题",
                "code": "contractTitle",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "合同编号",
                "code": "no",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "商品名称",
                "code": "name",
                "basic": true
            }
        ],
        "sortFields": []
    };

    export default {
        name: 'swb-contract-goods-list-for-select',
        desc: '合同商品选择列表',
        props: {
            shopDeviceSvcSubNos: {
                type: Array,
                default: null
            },
            realComId: {
                type: Number,
                default: null
            },
            catId: {
                type: Number,
                default: null
            },
            brandId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                //
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                contractGoodsList: [],
                selectContractGoods: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //----------------------搜索排序----------------------------
            this.queryConfig = searchConfigData || {};
            //
            this.toGetContractList();
        },
        methods: {
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //缓存查询条件
                this.pageNumber = 1;
                this.toGetContractList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.toGetContractList();
            },
            toGetContractList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.typeFlag = 'goods';
                filterItems.offline = true;
                filterItems.confirmed = true;
                filterItems.draftFlag = false;
                filterItems.curValid = true;
                filterItems.deleted = false;
                filterItems.closed = false;
                if (!Utils.isNoB(self.catId)) {
                    filterItems.catId = self.catId;
                }
                if (!Utils.isNoB(self.brandId)) {
                    filterItems.brandId = self.brandId;
                }
                if (!Utils.isNoB(self.realComId)) {
                    filterItems.realComId = self.realComId;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading("数据查询中.....");
                contractApi.getContractGoodsPagedList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        self.contractGoodsList = result.data.rows || [];
                        //
                        let pagination = result.data.pagination;
                        if (pagination != null) {
                            self.totalCount = pagination.totalCount;
                            self.pageNumber = pagination.pageNumber;
                            self.pageSize = pagination.pageSize;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 移除设备
            doDel: function (shopDeviceSvcSubNoId) {
                let self = this;
                let shopDeviceSvcSubNos = this.shopDeviceSvcSubNos;
                if (!Utils.isNoB(shopDeviceSvcSubNos) && shopDeviceSvcSubNos.length == 1) {
                    MsgBox.warning("至少保留一个设备！");
                    return;
                } else if (!Utils.isNoB(shopDeviceSvcSubNos) && shopDeviceSvcSubNos.length > 0) {
                    for (let i = 0; i < shopDeviceSvcSubNos.length; i++) {
                        let shopDeviceSvcSubNo = shopDeviceSvcSubNos[i];
                        if (!Utils.isNoB(shopDeviceSvcSubNoId) && shopDeviceSvcSubNoId == shopDeviceSvcSubNo.id) {
                            shopDeviceSvcSubNos.splice(i, 1);
                            break;
                        }
                    }
                    this.shopDeviceSvcSubNos = Utils.merge([], shopDeviceSvcSubNos);
                }
            },
            // 选择合同及商品
            handleCurrentChange: function (val) {
                this.selectContractGoods = Utils.merge({}, val);
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let result = {};
                let shopDeviceSvcSubNos = this.shopDeviceSvcSubNos;
                if (!Utils.isNoB(shopDeviceSvcSubNos) && shopDeviceSvcSubNos.length > 0) {
                    for (let i = 0; i < shopDeviceSvcSubNos.length; i++) {
                        let shopDeviceSvcSubNo = shopDeviceSvcSubNos[i];
                        if (!Utils.isNoB(shopDeviceSvcSubNo.imported) && !shopDeviceSvcSubNo.imported) {
                            result.type = "warn";
                            result.message = "请把不能关联合同的设备移除！";
                            return result;
                        }
                    }
                } else {
                    result.type = "warn";
                    result.message = "请选择要关联合同的设备！";
                    return result;
                }
                let contractGoods = this.selectContractGoods;
                if (!Utils.isNoB(contractGoods) && contractGoods.id > 0) {
                    let selectData = {
                        shopDeviceSvcSubNoIds: shopDeviceSvcSubNos.pluck("id"),
                        contractId: contractGoods.contractId,
                        skuId: contractGoods.skuId
                    };
                    result.type = "info";
                    result.data = selectData;
                } else {
                    result.type = "warn";
                    result.message = "请选择要关联的合同及商品！";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractGoodsListForSelect.vue